/* Review carousel: as many cards as fit (1 phone, 2 tablet, 3 laptop, 4 wide), swipe or arrows move one card.
   The step is measured from the first card + the track gap, so it follows the CSS breakpoints. */
(function () {
  function initOne(car) {
    var track = car.querySelector('[data-pz-revcar-track]');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || cards.length < 2 || car.dataset.pzReady) return;
    car.dataset.pzReady = '1';
    var prev = car.querySelector('[data-pz-revcar-go="-1"]');
    var next = car.querySelector('[data-pz-revcar-go="1"]');
    var bar = car.parentNode.querySelector('[data-pz-revcar-bar]');
    var n = cards.length, cur = 0, stops = 1, segs = [];
    function gap() { var s = getComputedStyle(track); return parseFloat(s.columnGap || s.gap) || 0; }
    function step() { return (cards[0].getBoundingClientRect().width + gap()) || 1; }
    function perView() { return Math.max(1, Math.min(n, Math.round((track.clientWidth + gap()) / step()))); }
    function build() {
      var s = n - perView() + 1;
      if (s === stops && segs.length) return;
      stops = s;
      if (!bar) return;
      bar.innerHTML = '';
      bar.hidden = stops < 2;
      for (var i = 0; i < stops; i++) {
        var seg = document.createElement('span');
        (function (k) { seg.addEventListener('click', function () { go(k); }); })(i);
        bar.appendChild(seg);
      }
      segs = Array.prototype.slice.call(bar.children);
    }
    function mark(i) {
      cur = i;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= stops - 1;
      segs.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    }
    function go(i, instant) {
      i = Math.max(0, Math.min(stops - 1, i));
      track.scrollTo({ left: i * step(), behavior: instant ? 'auto' : 'smooth' });
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var i = track.scrollLeft >= max - 2 ? stops - 1 : Math.round(track.scrollLeft / step());
      i = Math.max(0, Math.min(stops - 1, i));
      if (i !== cur) mark(i);
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(cur - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { go(cur + 1); e.preventDefault(); }
    });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { build(); cur = Math.min(cur, stops - 1); mark(cur); go(cur, true); }, 120);
    });
    build(); mark(0);
    window.addEventListener('load', function () { build(); mark(Math.min(cur, stops - 1)); });
  }
  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pz-revcar]')).forEach(initOne);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
